import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)
var language=JSON.parse(window.localStorage.getItem("language")) || 0
export default new vuex.Store({
	state: {
		websock: null, //websock对象
		websockUrl:WEBSOCKETSEVERS+'?token=',
		websockBtn:1,
		websockTimer:null,
		language:language,
		nowCaseItem:{},
		workBtn:false,
		workImgBox:{
			url:'',
			status:false
		},
    websockList:[],
    caseId:''
	},
	mutations: {
		websockStore(state, token) {
      console.log(state)
			var timer=null;
			if (token == null) {
				state.websock.close()
				clearInterval(state.websockTimer)
				state.websock=null;
				console.log('websocket 连接关闭！')
				return
			}else{
				init();
			}
			function init(){
				state.websock = new WebSocket(state.websockUrl + token);
				state.websock.onopen = websocketopen();
				state.websock.onclose = websocketclose;
				state.websock.onerror = websocketclose;
			}

			function websocketopen(){
				console.log('连接成功')
				websocketSendHeart()
			}
			function websocketSendHeart(status){
				var data = {
					type: 'user',
					actType: 4
				}
				state.websockTimer = setInterval(() => {
					state.websock.send(JSON.stringify(data))
				}, 5000)
			}
			function websocketclose(){  //关闭
		    	console.log("WebSocket关闭");
		    	clearInterval(state.websockTimer)
		    	state.websockBtn=state.websockBtn+1;
				var languageName ='';
				if(state.language == 0){
					languageName='连接已断开，是否重新连接?'
				}else{
					languageName='The connection has been disconnected. Do you want to reconnect?'
				}
		    	var r=confirm(languageName)
		    	if(r){
					init();
		    	}
		  }
		},
		languageFun(state,index){
      // console.log
			state.language=index;
		},
		workData(state,data){
      console.log(state)
			state.nowCaseItem=data
		},
		workBtnFun(state,status){
			state.workBtn=status
		},
		workImgBoxFun(state,obj){
			state.workImgBox=obj
		},
    websockListFun(state,list){
      if(list){
        state.websockList.push(list)
      }else{
        state.websockList=[]
      }
    },
    caseIdFun(state,id){
      state.caseId=id
    }
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js